export var props = {
  type: {
    type: String,
    default: 'diamond-with-coin'
  },
  before: {
    type: Boolean,
    default: false
  },
  theme: {
    type: String,
    default: 'light'
  }
};